import type { ReactNode } from 'react';
import cx from 'classnames';

// @ts-expect-error - no TypeScript definitions yet
import PageLayout from 'src/components/PageLayout';

import styles from './ConsentLayout.module.scss';

interface ConsentLayoutProps {
  className?: string;
  children: ReactNode;
}

export const ConsentLayout = ({ className, children }: ConsentLayoutProps) => (
  <PageLayout className={cx(styles.root, className)}>
    <div className={styles.card}>{children}</div>
  </PageLayout>
);
